import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { StringInput } from "~/OnboardingApp/components";
import { AdditionalTermsCheckbox } from "./AdditionalTermsCheckbox";
import { TermsCheckbox } from "./TermsCheckbox";

export const InputSection: FC = () => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={{ base: 4, md: 6 }} w="full">
      <StringInput
        id="email"
        placeholder={t("onboarding.emailPage.placeholders.email")}
      />

      <Flex direction="column" gap={2} w="full">
        <TermsCheckbox />
        <AdditionalTermsCheckbox />
      </Flex>
    </Flex>
  );
};
